import { List } from 'immutable';
import { createSelector } from '@reduxjs/toolkit';

// TODO: закомментированы куски кода в связи с задачей https://jira.tennisi.it/browse/SITE-997, скорее всего в будущем этот код понадобится поэтому пока оставим
const MAX_GRID_COLUMN_COUNT = 3;
// const MIN_GRID_COLUMN_COUNT = 3;
// const MIN_GRID_COLUMN_SCREEN_WIDTH = 1380;

export default (matchSportId, stakeTypeGroupBySportId) => {
  /**
   * Create "visible grid's stake type group ids" selector.
   *
   * @param {object} query
   * @param {number} [query.matchId] - if `sportId` unavailable in component
   * @return {function(state:object):Immutable.List<keyof typeof StakeTypeGroup>}
   */
  return ({ matchId } = {}) => {
    /**
     * @param {object} state
     * @param {number} [sportId]
     * @return {Immutable.List<keyof typeof StakeTypeGroup>}
     */

    const stakeTypeGroupIds = (state, { sportId } = {}) => {
      const _sportId = sportId || matchSportId(state, { matchId });

      return stakeTypeGroupBySportId(state, { sportId: _sportId });
    };

    return createSelector(
      // (state) => state.screen.innerWidth,
      stakeTypeGroupIds,
      /**
       // * @param {number} screenWidth
       * @param {Immutable.List<keyof typeof StakeTypeGroup>} stakeTypeGroupIds
       */
      (
        // screenWidth,
        stakeTypeGroupIds,
      ) => {
        if (!stakeTypeGroupIds || stakeTypeGroupIds.size === 0) {
          return List();
        }

        // if (screenWidth <= MIN_GRID_COLUMN_SCREEN_WIDTH) {
        //   return stakeTypeGroupIds.slice(0, MIN_GRID_COLUMN_COUNT);
        // }

        return stakeTypeGroupIds.slice(0, MAX_GRID_COLUMN_COUNT);
      },
    );
  };
};
